import React, { Suspense } from 'react';
import { Spin } from 'antd';
import { useDispatch, useSelector } from 'umi';
import * as TaskAutomationSelectors from '@/selectors/taskAutomationSelectors';
import Drawer from '@/components/Drawer';
import { F, INTL_ACTION, INTL_ENTITY } from '@/utils/intl';

// The flow editor pulls in @xyflow/react — keep it out of the main bundle
const FlowEditor = React.lazy(() => import('./FlowEditor'));

const TaskAutomationDrawer: React.FC = () => {
  const dispatch = useDispatch();
  const visible = useSelector(TaskAutomationSelectors.selectTaskAutomationVisible);
  const currentAutomation = useSelector(TaskAutomationSelectors.selectTaskAutomationCurrentAutomation);

  const handleClose = () => {
    dispatch({
      type: 'taskAutomation/close',
    });
  };

  return (
    <Drawer
      title={currentAutomation ? currentAutomation.name : <F entity={INTL_ENTITY.TASK_AUTOMATION} action={INTL_ACTION.NEW} />}
      width="100%"
      onClose={handleClose}
      onOpenChange={handleClose}
      open={visible}
      destroyOnHidden
    >
      {visible && (
        <Suspense fallback={<Spin style={{ width: '100%', marginTop: 48 }} />}>
          <FlowEditor automation={currentAutomation} />
        </Suspense>
      )}
    </Drawer>
  );
};

export default TaskAutomationDrawer;
